import { render, staticRenderFns } from "./Gost.vue?vue&type=template&id=452135e3&lang=pug&"
import script from "./Gost.vue?vue&type=script&lang=js&"
export * from "./Gost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports